export const SessionStorageKey = {
    ManageUserUserName : "manage_user_username",
    OperationSuccessUserName : "operation_success_username",
    UserContactUsername: "user_contact_user_name",
    MFAResetUserName: "mfa_reset_user_name",
    OrgUserSupportUserName: "org_user_support_user_name",
    ContactAssignUsername: "contact_assign_user_name",
    ForgotPasswordUserName: "forgot_pwd_user_name"
}